import { api } from 'api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFaqCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload) => api.faq.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faqList'] })

      toaster.create({
        type: 'success',
        title: 'Элемент добавлен успешно',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при попытке добавить элемент',
        description: err.message,
      })
    },
  })
}
